export default "__VITE_ASSET__3baef6c7__"